import { Group, Stack } from '@mantine/core';
import { ReactNode } from 'react';
import { baseBlack } from '../../../styles/design-tokens';
import { Text } from '../../../ui-library/typography/typography';

type Props = {
  metadata: { label: string; value: string | ReactNode }[];
  textColor?: string;
};

export const TaskMetadataList = ({ metadata, textColor }: Props) => {
  return (
    <Stack gap={2}>
      {metadata.map(({ label, value }) => (
        <Group key={label} justify="space-between">
          <Text size="small" color={textColor ?? baseBlack}>
            {label}
          </Text>
          {typeof value === 'string' ? (
            <Text size="small" color={textColor ?? baseBlack}>
              {value}
            </Text>
          ) : (
            value
          )}
        </Group>
      ))}
    </Stack>
  );
};
